import {_, React, observer, observable, computed, action, useLocalStore, pluralize, Fragment} from '@api'
import {MenuDivider} from '@blueprintjs/core'
import {useVipLocalStore, VipLocalStore, CatalogLibrariesStore, ContextMenuItem, DefaultCatalogContextMenuItems, ICatalogLibrariesContextMenuExtra, useCatalogLibrariesStore} from '@modules'
import {StoresInstance} from '@stores/StoresInstance'

import * as css from './CatalogLibrariesContextMenu.css'

/// region Store

export class CatalogLibrariesContextMenuStore extends VipLocalStore {
  constructor(stores: StoresInstance,public store: CatalogLibrariesStore) {
    super(stores)
  }

  @computed get extra() {
    return this.contextMenu.extra as ICatalogLibrariesContextMenuExtra
  }

  @computed get group() {
    const {groupBy, extra: {field}} = this

    return field ? groupBy.groupingForField(field) : null
  }

  @computed get workspaceFields() {
    const {catalog, extra: {workspace}} = this

    if (!workspace?.catalog?.index) return []

    return catalog.fieldByIndex[workspace.catalog.index]
  }
}

export const CatalogLibrariesContextMenuStoreContext = React.createContext<CatalogLibrariesContextMenuStore>(null)
export const useCatalogLibrariesContextMenuStore = () => React.useContext(CatalogLibrariesContextMenuStoreContext)

/// endregion

/// region Components

export const CatalogLibrariesContextMenu = observer(function CatalogLibrariesContextMenu() {
  const parentStore = useCatalogLibrariesStore(),
    store = useVipLocalStore((ws) => new CatalogLibrariesContextMenuStore(ws, parentStore))

  return (
    <CatalogLibrariesContextMenuStoreContext.Provider value={store}>
      <GroupByCatalogWorkspaceContextMenuItem/>
      <GroupByCatalogLibrariesSidebarField />
      <MenuDivider title='Libraries' />
      <CollapseAndExpandAllGroupsMenuItems />
      <MenuDivider />
      <DefaultCatalogContextMenuItems />
    </CatalogLibrariesContextMenuStoreContext.Provider>)
});

const CollapseAndExpandAllGroupsMenuItems = observer(function CollapseAllGroupsMenuItem() {
    const {store: {collapseAll, expandAll}} = useCatalogLibrariesContextMenuStore()

    return (<Fragment>
      <ContextMenuItem icon='double-chevron-up' text='Collapse All' onClick={collapseAll}/>
      <ContextMenuItem icon='double-chevron-down' text='Expand All' onClick={expandAll}/>
    </Fragment>)
})
const GroupByCatalogWorkspaceContextMenuItem = observer(function GroupByCatalogWorkspaceContextMenuItem() {
    const {extra: {workspace}, groupBy, workspaceFields} = useCatalogLibrariesContextMenuStore()

    return (<Fragment>
      {(workspaceFields ?? []).map((f) => {
        const group = groupBy.groupingForField(f)
        return group && <ContextMenuItem key={f.field} text={`Group by '${group.groupTitle}'`} icon={group.isInHierarchy ? 'tick' : 'blank'} onClick={() => group.toggleInHierarchy()}/>
      })}
    </Fragment>)
});

const GroupByCatalogLibrariesSidebarField = observer(function GroupByCatalogLibrariesSidebarField() {
    const {extra: {field}, group, groupBy} = useCatalogLibrariesContextMenuStore()

  if (!group) return null

    return (<Fragment>
      <ContextMenuItem text={`Group by '${group.groupTitle}'`} icon={group.isInHierarchy ? 'tick' : 'blank'} onClick={() => groupBy.onClickGroupBy_modifyHierarchy(field.field)}/>
    </Fragment>)
})
/// endregion




// WEBPACK FOOTER //
// ./src/modules/catalog/sidebar/CatalogLibrariesContextMenu.tsx